import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';

class ImageSphere extends BasicComponent {
    getType() { return "Image"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        const base = super.construct(context, prefab).getRootNode();
        console.log("context variable:",context);
        console.log("context.$store.getters.mediaURL:",context.$store.getters.mediaURL);
        
        this.prefab = prefab;
        this.context = context;

        let photoDome_base = new BABYLON.PhotoDome("SituationImage_"+ this.prefab.getSphereImageID(), "",{ 
            resolution:32,
            faceForward: false,
            size: 400  
        }, window.scene);
        photoDome_base.parent = base;

        let photoDome_overlay = new BABYLON.PhotoDome("SituationImage_"+ this.prefab.getSphereImageID() + "_Overlay", "",{ 
            resolution: 32,
            faceForward: false,
            size: 398  
        }, window.scene);
        photoDome_overlay.parent = base;
        photoDome_overlay.mesh.isPickable = false;
        
        if(this.context.activeLanguage){
            photoDome_base.photoTexture = this.getPanoramaBase(); 
            photoDome_overlay.photoTexture = this.getPanoramaOverlay(); 
        }

        window.addEventListener("languageChange", () => {
            photoDome_base.photoTexture = this.getPanoramaBase(); 
            photoDome_overlay.photoTexture = this.getPanoramaOverlay(); 
        });

        return base;
    }

    getPanoramaBase(){
        let roomName = this.prefab.name + "_base";
        let touchString = "";
        if(this.context.isTouchDeviceOn && this.context.deviceWidth < 1400)
            touchString = "_4K";
        
        let path = this.context.publicPath + '/media' + this.context.$store.getters.mediaURL + "/panorama/base/" + roomName.replaceAll(" ", "_") + touchString + ".avif"

        let photoDomeTexture = new BABYLON.Texture(path, window.scene, true, false, BABYLON.Texture.TRILINEAR_SAMPLINGMODE);
        photoDomeTexture.wrapU = photoDomeTexture.wrapV = BABYLON.Constants.WRAP_ADDRESSMODE;

        return photoDomeTexture;
    }

    getPanoramaOverlay(){
        let langCode = this.context.activeLanguage.shortCode;

        let roomName = this.prefab.name;
        let touchString = "";
        if(this.context.isTouchDeviceOn && this.context.deviceWidth < 1400)
            touchString = "_4K";

        let path = this.context.publicPath + '/media' + this.context.$store.getters.mediaURL + "/panorama/overlay/" + roomName.replaceAll(" ", "_") + "/"  + roomName.replaceAll(" ", "_") + "_" + langCode + "NEW"  + touchString + ".png"

        let photoDomeTexture = new BABYLON.Texture(path, window.scene, true, false, BABYLON.Texture.TRILINEAR_SAMPLINGMODE);
        photoDomeTexture.wrapU = photoDomeTexture.wrapV = BABYLON.Constants.WRAP_ADDRESSMODE;
        photoDomeTexture.hasAlpha = true;

        return photoDomeTexture;
    }
}

export default ImageSphere;

